// Uses the existing authenticated WhatsApp inbox and sender. No optimistic send or retry:
// a transport failure after provider acceptance can be ambiguous.
export function whatsappReplies(client, scope) {
  const config = { sparkScope: scope };
  return {
    conversations: async () => (await client.get('/api/v1/whatsapp/conversations',
      { ...config, params: { page: 0, size: 50 } })).data.content,
    messages: async id => (await client.get(`/api/v1/whatsapp/conversations/${encodeURIComponent(id)}/messages`,
      { ...config, params: { page: 0, size: 50 } })).data.content,
    send: async (conversation, body) => {
      if (!conversation?.id || !conversation.phoneNumberId || !body?.trim())
        throw new Error('Choose a conversation and enter a message');
      return (await client.post('/api/v1/whatsapp/messages/send',
        { conversationId: conversation.id, phoneNumberId: conversation.phoneNumberId, messageBody: body.trim() }, config)).data;
    }
  };
}
